import React from 'react';
import styled from "styled-components";
import { BookingType } from '../../Components/Types';
import { DashboardIcon, Header } from '../../Components/PageComponents';
import BookingsTable from './BookingsTable';
import ReactGA from "react-ga4";

type MyBookingsProps = {
    bookings: BookingType[][];
}
const Container = styled.div`
    width: 80%;
    @media (max-width: 1050px) {
        width: 90%;
    }
`;
const TableContainer = styled.div`
    @media (max-width: 1700px) {
        overflow-x: auto;
    }
    @media (max-width: 1050px) {
        overflow-x: hidden;
    }
`;
function MyBookings({ bookings }: MyBookingsProps) {
    
    ReactGA.send({ hitType: "pageview", page: window.location.pathname });

    

    return (
        <Container>
            <DashboardIcon src="/images/homepage/calendar.png"/>
            <Header>My Bookings</Header>
            <TableContainer>
                <BookingsTable bookings={bookings}/>
            </TableContainer>
        </Container>
    );
}
export default MyBookings;
